// Entry point for Webpack build system
import '@/styles/main.css';
import { inject } from '@vercel/analytics';
inject();
